<template>
  <aside class="d-block col-lg-7 col-xxs-12">
    <section :class="containerClass">
      <component
        :is="getVueComponent(component.type)"
        v-for="(component, index) in components"
        :key="index"
        :configurations="component.configurations"
        :components="component.components"
      />
    </section>
  </aside>
</template>

<script>
import Vue from 'vue'
import LeafComponentSelector from '@/mixins/leaf-component-selector'

export default Vue.extend({
  name: 'LinkCollection',
  mixins: [
    LeafComponentSelector
  ],
  props: {
    configurations: {
      type: Object,
      default: () => {}
    },
    components: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    containerClass () {
      if (this.configurations.direction === 'horizontal') { return 'd-flex flex-sm-row flex-xxs-column justify-content-sm-around justify-content-xxs-between align-items-center w-100 h-100 py-4' } else { return 'd-flex flex-column justify-content-sm-around justify-content-xxs-between align-items-sm-center align-items-xxs-start w-100 h-100 py-5' }
    }
  }

})
</script>
